import React, { FC, Ref, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Col, DatePicker, Form, FormInstance, InputNumber, Select } from 'antd'
import { SGeneralForms } from 'shj-components'

interface IAddOrEditProps {
  typesList?: any[]
  onFinish?: (values: object) => void
  companyList?: any[]
  formDetails?: object
  ref: Ref<any>
}
const AddOrEdit: FC<IAddOrEditProps> = React.forwardRef(
  (props: IAddOrEditProps, addOrEditRef: Ref<any>) => {
    const formRef = useRef<Ref<any> & { onFormRef: () => FormInstance }>(null)
    const { typesList, onFinish, companyList, formDetails, choseData } = props
    const [disabled, setDisabled] = useState(false)

    /**
     * 使用ref后对外暴露的相关方法
     */
    useImperativeHandle(addOrEditRef, () => ({
      onFinish,
      onFormRef() {
        return formRef.current?.onFormRef()
      },
    }))

    // useEffect(() => {
    //   const form = formRef.current?.onFormRef()
    //   console.log(formDetails);

    //   form?.setFieldsValue({ ...formDetails })
    // }, [formDetails])

    useEffect(() => {
      setDisabled(choseData?.id ? true : false)
    }, [choseData])

    const closeModal = () => {
      const form = formRef.current?.onFormRef()
      form?.resetFields()
    }

    return (
      <SGeneralForms
        layout="vertical"
        ref={formRef}
        // closeModal={closeModal}
        onFinish={onFinish}
        configs={[
          {
            title: '',
            formItem: [
              { name: 'id', label: '', hidden: true },
              {
                spanCol: 24,
                // isDependencies: true,
                name: 'yearMonth',
                label: '年月',
                required: true,
                children: (
                  <DatePicker
                    format="YYYY-MM"
                    picker="month"
                    disabled={disabled}
                    style={{ width: '100%' }}
                    placeholder="请选择日期"
                  />
                ),
              },
              {
                name: 'suitCompanys',
                label: '适用门店',
                spanCol: 24,
                required: true,
                children: (
                  <Select
                    mode="multiple"
                    placeholder="请选择"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    // filterOption={(input, option) =>
                    //   option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
                    // }
                  >
                    {companyList &&
                      companyList.map((item: any) => (
                        <Select.Option key={item.orgId} value={item.orgId}>
                          {item.companyName}
                        </Select.Option>
                      ))}
                  </Select>
                ),
              },
              {
                spanCol: 24,
                // isDependencies: true,
                name: 'category',
                label: '类型',
                required: true,
                children: (
                  <Select style={{ width: '100%' }} disabled={disabled} placeholder="请选择" showSearch
                          allowClear
                          optionFilterProp="children">
                    {typesList &&
                      typesList.map((item: any) => (
                        <Select.Option key={item.priKey} value={item.priKey}>
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                ),
              },
              {
                name: 'startDate',
                label: '目标业绩开始时间',
                spanCol: 24,
                required: true,
                children: (
                  <DatePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    showTime={true}
                    style={{ width: '100%' }}
                    placeholder="请选择日期"
                  />
                ),
              },
              {
                name: 'endDate',
                label: '目标业绩结束时间',
                spanCol: 24,
                required: true,
                children: (
                  <DatePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    showTime={true}
                    style={{ width: '100%' }}
                    placeholder="请选择日期"
                  />
                ),
              },
              {
                name: 'targetAmount',
                label: '月业绩目标（万）',
                spanCol: 24,
                required: true,
                children: <InputNumber step="0.0001" min={0} placeholder="请输入内容" />,
              },
            ],
          },
        ]}
      />
    )
  }
)

export default AddOrEdit
